import { render } from "./UserRoleForm.vue?vue&type=template&id=092f4f94&ts=true"
import script from "./UserRoleForm.vue?vue&type=script&lang=ts"
export * from "./UserRoleForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__